import { onError } from '@apollo/client/link/error';
import { DATADOG_TRACE_ID_HEADER } from '@modernloop/shared/constants';

import logError from 'src/utils/logError';
import logMessage from 'src/utils/logMessage';

export const ErrorLink = onError(({ graphQLErrors, operation, response }) => {
  if (graphQLErrors && graphQLErrors.length > 0) {
    // Process all errors
    graphQLErrors.forEach((error) => {
      let exception: Error | undefined =
        error.message && error.message !== 'Sorry, something went wrong.' ? new Error(error.message) : undefined;
      if (!exception && Array.isArray(error.extensions?.errorInfo) && error.extensions.errorInfo.length) {
        exception = new Error(`${error.extensions.errorInfo[0].domain} - ${error.extensions.errorInfo[0].reason}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if (!exception && (error as any).cause?.message) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        exception = new Error(`GraphQL Error: ${(error as any).cause?.message}`);
      } else if (!exception && error.message) {
        exception = new Error(`GraphQL Error: ${error.message}`);
      } else if (!exception) {
        exception = new Error('GraphQL Error');
      }

      const extra = {
        message: error.message,
        path: error.path,
        locations: error.locations,
        extensions: error.extensions,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errorType: (error as any).errorType,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        exception: (error as any).exception,
        operation: operation.operationName,
        variables: operation.variables,
        response,
        datadog_trace_id: '',
      };

      const context = operation.getContext();
      if (context.response?.headers?.get) {
        extra.datadog_trace_id = context.response.headers.get(DATADOG_TRACE_ID_HEADER);
      }

      logError(exception, extra);
      logMessage('GraphQLError', 'error', error);
    });
  }
});
